import { FC } from "react";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import {
  landingActiveStepAtom,
  LandingStepEnum,
  useLandingActions,
  useLandingLangSwitch,
} from "@ryde/utils-landings";

import {
  StepChooseStationWestNegev,
  StepErrorWestNegev,
  StepFinishedWestNegev,
  StepLoginWestNegev,
  StepVerifyCodeWestNegev,
} from "../../steps-westnegev";

export const WestNegevLandingStepsContainer: FC = () => {
  const step = useRecoilValue(landingActiveStepAtom);
  const { goToStep } = useLandingActions();
  useLandingLangSwitch();

  return (
    <main className="landing-outside-container">
      <div className="landing-container">
        <button
          type="button"
          className="landing-logo"
          onClick={() => goToStep(LandingStepEnum.LoginStep)}
          aria-label="Go to homepage"
        >
          <img
            className="landing-logo__img"
            src={RASTER_LANDINGS.WestnegevLogoPNG}
            alt="West Negev logo"
            width="206"
            height="117"
          />
        </button>
        {(!step || step === LandingStepEnum.LoginStep) && (
          <StepLoginWestNegev />
        )}
        {step === LandingStepEnum.VerificationStep && (
          <StepVerifyCodeWestNegev />
        )}
        {step === LandingStepEnum.ChooseStationStep && (
          <StepChooseStationWestNegev />
        )}
        {step === LandingStepEnum.FinishedStep && <StepFinishedWestNegev />}
        {step === LandingStepEnum.ErrorStep && <StepErrorWestNegev />}
      </div>
    </main>
  );
};
